import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import FormsIndex from "./FormsIndex";
import FormsCreate from "./FormsCreate";
import FormsEdit from "./FormsEdit";
import FormsDetail from "./FormsDetail";
import SEO from "../../../UI/SEO/SEO";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import FormsCopy from "./FormsCopy";
export const getFormsBaseRoute = () => getAdminBaseRoute() + "/forms";
export const getFormsIndexRoute = getFormsBaseRoute;
export const getFormsCreateRoute = () => getFormsBaseRoute() + "/create";
export const getFormsDetailRoute = () => getFormsBaseRoute() + "/:formId";
export const getFormsEditRoute = () => getFormsBaseRoute() + "/edit/:formId";
export const getFormsCopyRoute = () => getFormsBaseRoute() + "/copy/:formId";
export const getFormsBasePath = () => getAdminBasePath() + "/forms";
export const getFormsIndexPath = getFormsBasePath;
export const getFormsCopyPath = (formId) => getFormsBasePath() + `/copy/${formId}`;
export const getFormsCreatePath = () => getFormsBasePath() + "/create";
export const getFormsEditPath = (formId) => getFormsBasePath() + `/edit/${formId}`;
export const getFormsDetailPath = (formId) => getFormsBasePath() + `/${formId}`;
const AdminFormsRoutes = () => (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Forms" }), _jsxs(Switch, { children: [_jsx(Route, { component: FormsCreate, path: getFormsCreateRoute() }), _jsx(Route, { component: FormsEdit, path: getFormsEditRoute() }), _jsx(Route, { component: FormsCopy, path: getFormsCopyRoute() }), _jsx(Route, { component: FormsDetail, path: getFormsDetailRoute() }), _jsx(Route, { component: FormsIndex, path: getFormsIndexRoute() })] })] }));
export default AdminFormsRoutes;
